import type { ReactNode } from "react";

interface PageHeaderProps {
  title: string;
  subtitle?: string;
  actions?: ReactNode;
}

export const PageHeader = ({ title, subtitle, actions }: PageHeaderProps) => (
  <header className="flex flex-wrap items-center justify-between gap-3">
    <div>
      <h1 className="text-xl font-semibold text-ink-primary">{title}</h1>
      {subtitle ? (
        <p className="text-sm text-ink-secondary">{subtitle}</p>
      ) : null}
    </div>
    {actions ? <div className="flex gap-2">{actions}</div> : null}
  </header>
);